/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { AssignPodRequest } from "../../models/assignPodRequest.ts";

import type { ComputerInfo } from "../../models/computerInfo.ts";

import type { CreatePodRequest } from "../../models/createPodRequest.ts";

import type { CreateRaisedExpertRequest } from "../../models/createRaisedExpertRequest.ts";

import type { DesktopStream } from "../../models/desktopStream.ts";

import type { Expert } from "../../models/expert.ts";

import type { ExpertActivity } from "../../models/expertActivity.ts";

import type { ExpertAvatarJob } from "../../models/expertAvatarJob.ts";

import type { ExpertAvatarRequest } from "../../models/expertAvatarRequest.ts";

import type { ExpertAvatarUpdate } from "../../models/expertAvatarUpdate.ts";

import type { ExpertBudgetUpdate } from "../../models/expertBudgetUpdate.ts";

import type { ExpertCredentialRef } from "../../models/expertCredentialRef.ts";

import type { ExpertDetachPreview } from "../../models/expertDetachPreview.ts";

import type { ExpertIdentity } from "../../models/expertIdentity.ts";

import type { ExpertModeUpdate } from "../../models/expertModeUpdate.ts";

import type { ExpertPod } from "../../models/expertPod.ts";

import type { ExpertRun } from "../../models/expertRun.ts";

import type { ExpertSetupItem } from "../../models/expertSetupItem.ts";

import type { ExpertSkillsUpdate } from "../../models/expertSkillsUpdate.ts";

import type { ExpertSoulUpdate } from "../../models/expertSoulUpdate.ts";

import type { ExpertTemplate } from "../../models/expertTemplate.ts";

import type { ExpertWorkflowRef } from "../../models/expertWorkflowRef.ts";

import type { GrantCredentialsRequest } from "../../models/grantCredentialsRequest.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { HireRequest } from "../../models/hireRequest.ts";

import type { HireResult } from "../../models/hireResult.ts";

import type { InstallWorkflowRequest } from "../../models/installWorkflowRequest.ts";

import type { ListExpertTemplatesParams } from "../../models/listExpertTemplatesParams.ts";

import type { PendingExpertOnboarding } from "../../models/pendingExpertOnboarding.ts";

import type { RaiseResult } from "../../models/raiseResult.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listExpertsResponse200 = {
  data: Expert[];
  status: 200;
};

export type listExpertsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listExpertsResponseSuccess = listExpertsResponse200 & {
  headers: Headers;
};
export type listExpertsResponseError = listExpertsResponse401 & {
  headers: Headers;
};

export type listExpertsResponse =
  | listExpertsResponseSuccess
  | listExpertsResponseError;

export const getListExpertsUrl = () => {
  return `/api/experts`;
};

/**
 * List the user's active hired experts.
 * @summary List Experts
 */
export const listExperts = async (
  options?: RequestInit,
): Promise<listExpertsResponse> => {
  return customMutator<listExpertsResponse>(getListExpertsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListExpertsQueryKey = () => {
  return [`/api/experts`] as const;
};

export const getListExpertsQueryOptions = <
  TData = Awaited<ReturnType<typeof listExperts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listExperts>>, TError, TData>
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExpertsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExperts>>> = ({
    signal,
  }) => listExperts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExperts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExpertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExperts>>
>;
export type ListExpertsQueryError = HTTP401NotAuthenticatedErrorResponse;

export function useListExperts<
  TData = Awaited<ReturnType<typeof listExperts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExperts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExperts>>,
          TError,
          Awaited<ReturnType<typeof listExperts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExperts<
  TData = Awaited<ReturnType<typeof listExperts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExperts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExperts>>,
          TError,
          Awaited<ReturnType<typeof listExperts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExperts<
  TData = Awaited<ReturnType<typeof listExperts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExperts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Experts
 */

export function useListExperts<
  TData = Awaited<ReturnType<typeof listExperts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExperts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExpertsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Experts
 */
export const prefetchListExpertsQuery = async <
  TData = Awaited<ReturnType<typeof listExperts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExperts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListExpertsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type hireExpertResponse200 = {
  data: HireResult;
  status: 200;
};

export type hireExpertResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type hireExpertResponse404 = {
  data: void;
  status: 404;
};

export type hireExpertResponse409 = {
  data: void;
  status: 409;
};

export type hireExpertResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type hireExpertResponse503 = {
  data: void;
  status: 503;
};

export type hireExpertResponseSuccess = hireExpertResponse200 & {
  headers: Headers;
};
export type hireExpertResponseError = (
  | hireExpertResponse401
  | hireExpertResponse404
  | hireExpertResponse409
  | hireExpertResponse422
  | hireExpertResponse503
) & {
  headers: Headers;
};

export type hireExpertResponse =
  | hireExpertResponseSuccess
  | hireExpertResponseError;

export const getHireExpertUrl = () => {
  return `/api/experts`;
};

/**
 * @summary Hire Expert
 */
export const hireExpert = async (
  hireRequest: HireRequest,
  options?: RequestInit,
): Promise<hireExpertResponse> => {
  return customMutator<hireExpertResponse>(getHireExpertUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(hireRequest),
  });
};

export const getHireExpertMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hireExpert>>,
    TError,
    { data: HireRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hireExpert>>,
  TError,
  { data: HireRequest },
  TContext
> => {
  const mutationKey = ["hireExpert"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hireExpert>>,
    { data: HireRequest }
  > = (props) => {
    const { data } = props ?? {};

    return hireExpert(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HireExpertMutationResult = NonNullable<
  Awaited<ReturnType<typeof hireExpert>>
>;
export type HireExpertMutationBody = HireRequest;
export type HireExpertMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Hire Expert
 */
export const useHireExpert = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof hireExpert>>,
      TError,
      { data: HireRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof hireExpert>>,
  TError,
  { data: HireRequest },
  TContext
> => {
  return useMutation(getHireExpertMutationOptions(options), queryClient);
};
export type generateExpertAvatarResponse202 = {
  data: ExpertAvatarJob;
  status: 202;
};

export type generateExpertAvatarResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type generateExpertAvatarResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type generateExpertAvatarResponseSuccess =
  generateExpertAvatarResponse202 & {
    headers: Headers;
  };
export type generateExpertAvatarResponseError = (
  | generateExpertAvatarResponse401
  | generateExpertAvatarResponse422
) & {
  headers: Headers;
};

export type generateExpertAvatarResponse =
  | generateExpertAvatarResponseSuccess
  | generateExpertAvatarResponseError;

export const getGenerateExpertAvatarUrl = () => {
  return `/api/experts/avatars/generations`;
};

/**
 * @summary Generate Expert Avatar
 */
export const generateExpertAvatar = async (
  expertAvatarRequest: ExpertAvatarRequest,
  options?: RequestInit,
): Promise<generateExpertAvatarResponse> => {
  return customMutator<generateExpertAvatarResponse>(
    getGenerateExpertAvatarUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(expertAvatarRequest),
    },
  );
};

export const getGenerateExpertAvatarMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateExpertAvatar>>,
    TError,
    { data: ExpertAvatarRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateExpertAvatar>>,
  TError,
  { data: ExpertAvatarRequest },
  TContext
> => {
  const mutationKey = ["generateExpertAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateExpertAvatar>>,
    { data: ExpertAvatarRequest }
  > = (props) => {
    const { data } = props ?? {};

    return generateExpertAvatar(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateExpertAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateExpertAvatar>>
>;
export type GenerateExpertAvatarMutationBody = ExpertAvatarRequest;
export type GenerateExpertAvatarMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Generate Expert Avatar
 */
export const useGenerateExpertAvatar = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateExpertAvatar>>,
      TError,
      { data: ExpertAvatarRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateExpertAvatar>>,
  TError,
  { data: ExpertAvatarRequest },
  TContext
> => {
  return useMutation(
    getGenerateExpertAvatarMutationOptions(options),
    queryClient,
  );
};
export type getExpertAvatarGenerationResponse200 = {
  data: ExpertAvatarJob;
  status: 200;
};

export type getExpertAvatarGenerationResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getExpertAvatarGenerationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getExpertAvatarGenerationResponseSuccess =
  getExpertAvatarGenerationResponse200 & {
    headers: Headers;
  };
export type getExpertAvatarGenerationResponseError = (
  | getExpertAvatarGenerationResponse401
  | getExpertAvatarGenerationResponse422
) & {
  headers: Headers;
};

export type getExpertAvatarGenerationResponse =
  | getExpertAvatarGenerationResponseSuccess
  | getExpertAvatarGenerationResponseError;

export const getGetExpertAvatarGenerationUrl = (jobId: string) => {
  return `/api/experts/avatars/generations/${jobId}`;
};

/**
 * @summary Get Expert Avatar Generation
 */
export const getExpertAvatarGeneration = async (
  jobId: string,
  options?: RequestInit,
): Promise<getExpertAvatarGenerationResponse> => {
  return customMutator<getExpertAvatarGenerationResponse>(
    getGetExpertAvatarGenerationUrl(jobId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetExpertAvatarGenerationQueryKey = (jobId: string) => {
  return [`/api/experts/avatars/generations/${jobId}`] as const;
};

export const getGetExpertAvatarGenerationQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExpertAvatarGenerationQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExpertAvatarGeneration>>
  > = ({ signal }) =>
    getExpertAvatarGeneration(jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: jobId !== null && jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExpertAvatarGenerationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExpertAvatarGeneration>>
>;
export type GetExpertAvatarGenerationQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetExpertAvatarGeneration<
  TData = Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
          TError,
          Awaited<ReturnType<typeof getExpertAvatarGeneration>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpertAvatarGeneration<
  TData = Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
          TError,
          Awaited<ReturnType<typeof getExpertAvatarGeneration>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpertAvatarGeneration<
  TData = Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Expert Avatar Generation
 */

export function useGetExpertAvatarGeneration<
  TData = Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExpertAvatarGenerationQueryOptions(jobId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Expert Avatar Generation
 */
export const prefetchGetExpertAvatarGenerationQuery = async <
  TData = Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertAvatarGeneration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetExpertAvatarGenerationQueryOptions(jobId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type listExpertIdentitiesResponse200 = {
  data: ExpertIdentity[];
  status: 200;
};

export type listExpertIdentitiesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listExpertIdentitiesResponseSuccess =
  listExpertIdentitiesResponse200 & {
    headers: Headers;
  };
export type listExpertIdentitiesResponseError =
  listExpertIdentitiesResponse401 & {
    headers: Headers;
  };

export type listExpertIdentitiesResponse =
  | listExpertIdentitiesResponseSuccess
  | listExpertIdentitiesResponseError;

export const getListExpertIdentitiesUrl = () => {
  return `/api/experts/identities`;
};

/**
 * List the lightweight active and archived identity projection for chat.
 * @summary List Expert Identities
 */
export const listExpertIdentities = async (
  options?: RequestInit,
): Promise<listExpertIdentitiesResponse> => {
  return customMutator<listExpertIdentitiesResponse>(
    getListExpertIdentitiesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListExpertIdentitiesQueryKey = () => {
  return [`/api/experts/identities`] as const;
};

export const getListExpertIdentitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpertIdentities>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listExpertIdentities>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExpertIdentitiesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExpertIdentities>>
  > = ({ signal }) => listExpertIdentities({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpertIdentities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExpertIdentitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpertIdentities>>
>;
export type ListExpertIdentitiesQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useListExpertIdentities<
  TData = Awaited<ReturnType<typeof listExpertIdentities>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertIdentities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertIdentities>>,
          TError,
          Awaited<ReturnType<typeof listExpertIdentities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertIdentities<
  TData = Awaited<ReturnType<typeof listExpertIdentities>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertIdentities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertIdentities>>,
          TError,
          Awaited<ReturnType<typeof listExpertIdentities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertIdentities<
  TData = Awaited<ReturnType<typeof listExpertIdentities>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertIdentities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Identities
 */

export function useListExpertIdentities<
  TData = Awaited<ReturnType<typeof listExpertIdentities>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertIdentities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExpertIdentitiesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Identities
 */
export const prefetchListExpertIdentitiesQuery = async <
  TData = Awaited<ReturnType<typeof listExpertIdentities>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertIdentities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListExpertIdentitiesQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type listExpertPodsResponse200 = {
  data: ExpertPod[];
  status: 200;
};

export type listExpertPodsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listExpertPodsResponseSuccess = listExpertPodsResponse200 & {
  headers: Headers;
};
export type listExpertPodsResponseError = listExpertPodsResponse401 & {
  headers: Headers;
};

export type listExpertPodsResponse =
  | listExpertPodsResponseSuccess
  | listExpertPodsResponseError;

export const getListExpertPodsUrl = () => {
  return `/api/experts/pods`;
};

/**
 * @summary List Expert Pods
 */
export const listExpertPods = async (
  options?: RequestInit,
): Promise<listExpertPodsResponse> => {
  return customMutator<listExpertPodsResponse>(getListExpertPodsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListExpertPodsQueryKey = () => {
  return [`/api/experts/pods`] as const;
};

export const getListExpertPodsQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpertPods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listExpertPods>>, TError, TData>
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExpertPodsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpertPods>>> = ({
    signal,
  }) => listExpertPods({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpertPods>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExpertPodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpertPods>>
>;
export type ListExpertPodsQueryError = HTTP401NotAuthenticatedErrorResponse;

export function useListExpertPods<
  TData = Awaited<ReturnType<typeof listExpertPods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertPods>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertPods>>,
          TError,
          Awaited<ReturnType<typeof listExpertPods>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertPods<
  TData = Awaited<ReturnType<typeof listExpertPods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertPods>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertPods>>,
          TError,
          Awaited<ReturnType<typeof listExpertPods>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertPods<
  TData = Awaited<ReturnType<typeof listExpertPods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertPods>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Pods
 */

export function useListExpertPods<
  TData = Awaited<ReturnType<typeof listExpertPods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertPods>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExpertPodsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Pods
 */
export const prefetchListExpertPodsQuery = async <
  TData = Awaited<ReturnType<typeof listExpertPods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertPods>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListExpertPodsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type createExpertPodResponse200 = {
  data: ExpertPod;
  status: 200;
};

export type createExpertPodResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type createExpertPodResponse409 = {
  data: void;
  status: 409;
};

export type createExpertPodResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createExpertPodResponseSuccess = createExpertPodResponse200 & {
  headers: Headers;
};
export type createExpertPodResponseError = (
  | createExpertPodResponse401
  | createExpertPodResponse409
  | createExpertPodResponse422
) & {
  headers: Headers;
};

export type createExpertPodResponse =
  | createExpertPodResponseSuccess
  | createExpertPodResponseError;

export const getCreateExpertPodUrl = () => {
  return `/api/experts/pods`;
};

/**
 * @summary Create Expert Pod
 */
export const createExpertPod = async (
  createPodRequest: CreatePodRequest,
  options?: RequestInit,
): Promise<createExpertPodResponse> => {
  return customMutator<createExpertPodResponse>(getCreateExpertPodUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPodRequest),
  });
};

export const getCreateExpertPodMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExpertPod>>,
    TError,
    { data: CreatePodRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExpertPod>>,
  TError,
  { data: CreatePodRequest },
  TContext
> => {
  const mutationKey = ["createExpertPod"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExpertPod>>,
    { data: CreatePodRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createExpertPod(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExpertPodMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExpertPod>>
>;
export type CreateExpertPodMutationBody = CreatePodRequest;
export type CreateExpertPodMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Create Expert Pod
 */
export const useCreateExpertPod = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createExpertPod>>,
      TError,
      { data: CreatePodRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createExpertPod>>,
  TError,
  { data: CreatePodRequest },
  TContext
> => {
  return useMutation(getCreateExpertPodMutationOptions(options), queryClient);
};
export type createRaisedExpertResponse200 = {
  data: RaiseResult;
  status: 200;
};

export type createRaisedExpertResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type createRaisedExpertResponse404 = {
  data: void;
  status: 404;
};

export type createRaisedExpertResponse409 = {
  data: void;
  status: 409;
};

export type createRaisedExpertResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createRaisedExpertResponseSuccess =
  createRaisedExpertResponse200 & {
    headers: Headers;
  };
export type createRaisedExpertResponseError = (
  | createRaisedExpertResponse401
  | createRaisedExpertResponse404
  | createRaisedExpertResponse409
  | createRaisedExpertResponse422
) & {
  headers: Headers;
};

export type createRaisedExpertResponse =
  | createRaisedExpertResponseSuccess
  | createRaisedExpertResponseError;

export const getCreateRaisedExpertUrl = () => {
  return `/api/experts/raise`;
};

/**
 * @summary Create Raised Expert
 */
export const createRaisedExpert = async (
  createRaisedExpertRequest: CreateRaisedExpertRequest,
  options?: RequestInit,
): Promise<createRaisedExpertResponse> => {
  return customMutator<createRaisedExpertResponse>(getCreateRaisedExpertUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createRaisedExpertRequest),
  });
};

export const getCreateRaisedExpertMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRaisedExpert>>,
    TError,
    { data: CreateRaisedExpertRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRaisedExpert>>,
  TError,
  { data: CreateRaisedExpertRequest },
  TContext
> => {
  const mutationKey = ["createRaisedExpert"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRaisedExpert>>,
    { data: CreateRaisedExpertRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createRaisedExpert(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRaisedExpertMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRaisedExpert>>
>;
export type CreateRaisedExpertMutationBody = CreateRaisedExpertRequest;
export type CreateRaisedExpertMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Create Raised Expert
 */
export const useCreateRaisedExpert = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRaisedExpert>>,
      TError,
      { data: CreateRaisedExpertRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRaisedExpert>>,
  TError,
  { data: CreateRaisedExpertRequest },
  TContext
> => {
  return useMutation(
    getCreateRaisedExpertMutationOptions(options),
    queryClient,
  );
};
export type listExpertSetupItemsResponse200 = {
  data: ExpertSetupItem[];
  status: 200;
};

export type listExpertSetupItemsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listExpertSetupItemsResponseSuccess =
  listExpertSetupItemsResponse200 & {
    headers: Headers;
  };
export type listExpertSetupItemsResponseError =
  listExpertSetupItemsResponse401 & {
    headers: Headers;
  };

export type listExpertSetupItemsResponse =
  | listExpertSetupItemsResponseSuccess
  | listExpertSetupItemsResponseError;

export const getListExpertSetupItemsUrl = () => {
  return `/api/experts/setup`;
};

/**
 * What still stands between each expert's scheduled workflows and a schedule.
 * @summary List Expert Setup Items
 */
export const listExpertSetupItems = async (
  options?: RequestInit,
): Promise<listExpertSetupItemsResponse> => {
  return customMutator<listExpertSetupItemsResponse>(
    getListExpertSetupItemsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListExpertSetupItemsQueryKey = () => {
  return [`/api/experts/setup`] as const;
};

export const getListExpertSetupItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpertSetupItems>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listExpertSetupItems>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExpertSetupItemsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExpertSetupItems>>
  > = ({ signal }) => listExpertSetupItems({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpertSetupItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExpertSetupItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpertSetupItems>>
>;
export type ListExpertSetupItemsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useListExpertSetupItems<
  TData = Awaited<ReturnType<typeof listExpertSetupItems>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertSetupItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertSetupItems>>,
          TError,
          Awaited<ReturnType<typeof listExpertSetupItems>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertSetupItems<
  TData = Awaited<ReturnType<typeof listExpertSetupItems>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertSetupItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertSetupItems>>,
          TError,
          Awaited<ReturnType<typeof listExpertSetupItems>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertSetupItems<
  TData = Awaited<ReturnType<typeof listExpertSetupItems>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertSetupItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Setup Items
 */

export function useListExpertSetupItems<
  TData = Awaited<ReturnType<typeof listExpertSetupItems>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertSetupItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExpertSetupItemsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Setup Items
 */
export const prefetchListExpertSetupItemsQuery = async <
  TData = Awaited<ReturnType<typeof listExpertSetupItems>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertSetupItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListExpertSetupItemsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type listExpertTemplatesResponse200 = {
  data: ExpertTemplate[];
  status: 200;
};

export type listExpertTemplatesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listExpertTemplatesResponseSuccess =
  listExpertTemplatesResponse200 & {
    headers: Headers;
  };
export type listExpertTemplatesResponseError =
  listExpertTemplatesResponse422 & {
    headers: Headers;
  };

export type listExpertTemplatesResponse =
  | listExpertTemplatesResponseSuccess
  | listExpertTemplatesResponseError;

export const getListExpertTemplatesUrl = (
  params?: ListExpertTemplatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/experts/templates?${stringifiedParams}`
    : `/api/experts/templates`;
};

/**
 * Roster templates, narrowed by a search term and/or a marketplace category.
 *
 * Unpaginated: the roster is small, and every caller reads the whole list.
 * @summary List Expert Templates
 */
export const listExpertTemplates = async (
  params?: ListExpertTemplatesParams,
  options?: RequestInit,
): Promise<listExpertTemplatesResponse> => {
  return customMutator<listExpertTemplatesResponse>(
    getListExpertTemplatesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListExpertTemplatesQueryKey = (
  params?: ListExpertTemplatesParams,
) => {
  return [`/api/experts/templates`, ...(params ? [params] : [])] as const;
};

export const getListExpertTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpertTemplates>>,
  TError = HTTPValidationError,
>(
  params?: ListExpertTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListExpertTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExpertTemplates>>
  > = ({ signal }) =>
    listExpertTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpertTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExpertTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpertTemplates>>
>;
export type ListExpertTemplatesQueryError = HTTPValidationError;

export function useListExpertTemplates<
  TData = Awaited<ReturnType<typeof listExpertTemplates>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListExpertTemplatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertTemplates>>,
          TError,
          Awaited<ReturnType<typeof listExpertTemplates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertTemplates<
  TData = Awaited<ReturnType<typeof listExpertTemplates>>,
  TError = HTTPValidationError,
>(
  params?: ListExpertTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertTemplates>>,
          TError,
          Awaited<ReturnType<typeof listExpertTemplates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertTemplates<
  TData = Awaited<ReturnType<typeof listExpertTemplates>>,
  TError = HTTPValidationError,
>(
  params?: ListExpertTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Templates
 */

export function useListExpertTemplates<
  TData = Awaited<ReturnType<typeof listExpertTemplates>>,
  TError = HTTPValidationError,
>(
  params?: ListExpertTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExpertTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Templates
 */
export const prefetchListExpertTemplatesQuery = async <
  TData = Awaited<ReturnType<typeof listExpertTemplates>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: ListExpertTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListExpertTemplatesQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type archiveExpertResponse204 = {
  data: void;
  status: 204;
};

export type archiveExpertResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type archiveExpertResponse404 = {
  data: void;
  status: 404;
};

export type archiveExpertResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type archiveExpertResponseSuccess = archiveExpertResponse204 & {
  headers: Headers;
};
export type archiveExpertResponseError = (
  | archiveExpertResponse401
  | archiveExpertResponse404
  | archiveExpertResponse422
) & {
  headers: Headers;
};

export type archiveExpertResponse =
  | archiveExpertResponseSuccess
  | archiveExpertResponseError;

export const getArchiveExpertUrl = (expertId: string) => {
  return `/api/experts/${expertId}`;
};

/**
 * @summary Archive Expert
 */
export const archiveExpert = async (
  expertId: string,
  options?: RequestInit,
): Promise<archiveExpertResponse> => {
  return customMutator<archiveExpertResponse>(getArchiveExpertUrl(expertId), {
    ...options,
    method: "DELETE",
  });
};

export const getArchiveExpertMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveExpert>>,
    TError,
    { expertId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveExpert>>,
  TError,
  { expertId: string },
  TContext
> => {
  const mutationKey = ["archiveExpert"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveExpert>>,
    { expertId: string }
  > = (props) => {
    const { expertId } = props ?? {};

    return archiveExpert(expertId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveExpertMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveExpert>>
>;

export type ArchiveExpertMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Archive Expert
 */
export const useArchiveExpert = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveExpert>>,
      TError,
      { expertId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveExpert>>,
  TError,
  { expertId: string },
  TContext
> => {
  return useMutation(getArchiveExpertMutationOptions(options), queryClient);
};
export type getExpertResponse200 = {
  data: Expert;
  status: 200;
};

export type getExpertResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getExpertResponse404 = {
  data: void;
  status: 404;
};

export type getExpertResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getExpertResponseSuccess = getExpertResponse200 & {
  headers: Headers;
};
export type getExpertResponseError = (
  | getExpertResponse401
  | getExpertResponse404
  | getExpertResponse422
) & {
  headers: Headers;
};

export type getExpertResponse =
  | getExpertResponseSuccess
  | getExpertResponseError;

export const getGetExpertUrl = (expertId: string) => {
  return `/api/experts/${expertId}`;
};

/**
 * @summary Get Expert
 */
export const getExpert = async (
  expertId: string,
  options?: RequestInit,
): Promise<getExpertResponse> => {
  return customMutator<getExpertResponse>(getGetExpertUrl(expertId), {
    ...options,
    method: "GET",
  });
};

export const getGetExpertQueryKey = (expertId: string) => {
  return [`/api/experts/${expertId}`] as const;
};

export const getGetExpertQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpert>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExpert>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExpertQueryKey(expertId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpert>>> = ({
    signal,
  }) => getExpert(expertId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: expertId !== null && expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getExpert>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetExpertQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExpert>>
>;
export type GetExpertQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useGetExpert<
  TData = Awaited<ReturnType<typeof getExpert>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExpert>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpert>>,
          TError,
          Awaited<ReturnType<typeof getExpert>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpert<
  TData = Awaited<ReturnType<typeof getExpert>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExpert>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpert>>,
          TError,
          Awaited<ReturnType<typeof getExpert>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpert<
  TData = Awaited<ReturnType<typeof getExpert>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExpert>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Expert
 */

export function useGetExpert<
  TData = Awaited<ReturnType<typeof getExpert>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExpert>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExpertQueryOptions(expertId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Expert
 */
export const prefetchGetExpertQuery = async <
  TData = Awaited<ReturnType<typeof getExpert>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExpert>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetExpertQueryOptions(expertId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getExpertActivityResponse200 = {
  data: ExpertActivity;
  status: 200;
};

export type getExpertActivityResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getExpertActivityResponse404 = {
  data: void;
  status: 404;
};

export type getExpertActivityResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getExpertActivityResponseSuccess = getExpertActivityResponse200 & {
  headers: Headers;
};
export type getExpertActivityResponseError = (
  | getExpertActivityResponse401
  | getExpertActivityResponse404
  | getExpertActivityResponse422
) & {
  headers: Headers;
};

export type getExpertActivityResponse =
  | getExpertActivityResponseSuccess
  | getExpertActivityResponseError;

export const getGetExpertActivityUrl = (expertId: string) => {
  return `/api/experts/${expertId}/activity`;
};

/**
 * Daily chat-session and run counts for the expert's activity graph.
 * @summary Get Expert Activity
 */
export const getExpertActivity = async (
  expertId: string,
  options?: RequestInit,
): Promise<getExpertActivityResponse> => {
  return customMutator<getExpertActivityResponse>(
    getGetExpertActivityUrl(expertId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetExpertActivityQueryKey = (expertId: string) => {
  return [`/api/experts/${expertId}/activity`] as const;
};

export const getGetExpertActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpertActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertActivity>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExpertActivityQueryKey(expertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExpertActivity>>
  > = ({ signal }) =>
    getExpertActivity(expertId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: expertId !== null && expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExpertActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExpertActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExpertActivity>>
>;
export type GetExpertActivityQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useGetExpertActivity<
  TData = Awaited<ReturnType<typeof getExpertActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertActivity>>,
          TError,
          Awaited<ReturnType<typeof getExpertActivity>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpertActivity<
  TData = Awaited<ReturnType<typeof getExpertActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertActivity>>,
          TError,
          Awaited<ReturnType<typeof getExpertActivity>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpertActivity<
  TData = Awaited<ReturnType<typeof getExpertActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertActivity>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Expert Activity
 */

export function useGetExpertActivity<
  TData = Awaited<ReturnType<typeof getExpertActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertActivity>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExpertActivityQueryOptions(expertId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Expert Activity
 */
export const prefetchGetExpertActivityQuery = async <
  TData = Awaited<ReturnType<typeof getExpertActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertActivity>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetExpertActivityQueryOptions(expertId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type updateExpertAvatarResponse200 = {
  data: Expert;
  status: 200;
};

export type updateExpertAvatarResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type updateExpertAvatarResponse404 = {
  data: void;
  status: 404;
};

export type updateExpertAvatarResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateExpertAvatarResponseSuccess =
  updateExpertAvatarResponse200 & {
    headers: Headers;
  };
export type updateExpertAvatarResponseError = (
  | updateExpertAvatarResponse401
  | updateExpertAvatarResponse404
  | updateExpertAvatarResponse422
) & {
  headers: Headers;
};

export type updateExpertAvatarResponse =
  | updateExpertAvatarResponseSuccess
  | updateExpertAvatarResponseError;

export const getUpdateExpertAvatarUrl = (expertId: string) => {
  return `/api/experts/${expertId}/avatar`;
};

/**
 * @summary Update Expert Avatar
 */
export const updateExpertAvatar = async (
  expertId: string,
  expertAvatarUpdate: ExpertAvatarUpdate,
  options?: RequestInit,
): Promise<updateExpertAvatarResponse> => {
  return customMutator<updateExpertAvatarResponse>(
    getUpdateExpertAvatarUrl(expertId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(expertAvatarUpdate),
    },
  );
};

export const getUpdateExpertAvatarMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpertAvatar>>,
    TError,
    { expertId: string; data: ExpertAvatarUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExpertAvatar>>,
  TError,
  { expertId: string; data: ExpertAvatarUpdate },
  TContext
> => {
  const mutationKey = ["updateExpertAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExpertAvatar>>,
    { expertId: string; data: ExpertAvatarUpdate }
  > = (props) => {
    const { expertId, data } = props ?? {};

    return updateExpertAvatar(expertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExpertAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExpertAvatar>>
>;
export type UpdateExpertAvatarMutationBody = ExpertAvatarUpdate;
export type UpdateExpertAvatarMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Update Expert Avatar
 */
export const useUpdateExpertAvatar = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateExpertAvatar>>,
      TError,
      { expertId: string; data: ExpertAvatarUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateExpertAvatar>>,
  TError,
  { expertId: string; data: ExpertAvatarUpdate },
  TContext
> => {
  return useMutation(
    getUpdateExpertAvatarMutationOptions(options),
    queryClient,
  );
};
export type updateExpertBudgetResponse200 = {
  data: Expert;
  status: 200;
};

export type updateExpertBudgetResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type updateExpertBudgetResponse404 = {
  data: void;
  status: 404;
};

export type updateExpertBudgetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateExpertBudgetResponseSuccess =
  updateExpertBudgetResponse200 & {
    headers: Headers;
  };
export type updateExpertBudgetResponseError = (
  | updateExpertBudgetResponse401
  | updateExpertBudgetResponse404
  | updateExpertBudgetResponse422
) & {
  headers: Headers;
};

export type updateExpertBudgetResponse =
  | updateExpertBudgetResponseSuccess
  | updateExpertBudgetResponseError;

export const getUpdateExpertBudgetUrl = (expertId: string) => {
  return `/api/experts/${expertId}/budget`;
};

/**
 * @summary Update Expert Budget
 */
export const updateExpertBudget = async (
  expertId: string,
  expertBudgetUpdate: ExpertBudgetUpdate,
  options?: RequestInit,
): Promise<updateExpertBudgetResponse> => {
  return customMutator<updateExpertBudgetResponse>(
    getUpdateExpertBudgetUrl(expertId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(expertBudgetUpdate),
    },
  );
};

export const getUpdateExpertBudgetMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpertBudget>>,
    TError,
    { expertId: string; data: ExpertBudgetUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExpertBudget>>,
  TError,
  { expertId: string; data: ExpertBudgetUpdate },
  TContext
> => {
  const mutationKey = ["updateExpertBudget"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExpertBudget>>,
    { expertId: string; data: ExpertBudgetUpdate }
  > = (props) => {
    const { expertId, data } = props ?? {};

    return updateExpertBudget(expertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExpertBudgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExpertBudget>>
>;
export type UpdateExpertBudgetMutationBody = ExpertBudgetUpdate;
export type UpdateExpertBudgetMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Update Expert Budget
 */
export const useUpdateExpertBudget = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateExpertBudget>>,
      TError,
      { expertId: string; data: ExpertBudgetUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateExpertBudget>>,
  TError,
  { expertId: string; data: ExpertBudgetUpdate },
  TContext
> => {
  return useMutation(
    getUpdateExpertBudgetMutationOptions(options),
    queryClient,
  );
};
export type getV2GetExpertComputerResponse200 = {
  data: ComputerInfo;
  status: 200;
};

export type getV2GetExpertComputerResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetExpertComputerResponse404 = {
  data: void;
  status: 404;
};

export type getV2GetExpertComputerResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetExpertComputerResponseSuccess =
  getV2GetExpertComputerResponse200 & {
    headers: Headers;
  };
export type getV2GetExpertComputerResponseError = (
  | getV2GetExpertComputerResponse401
  | getV2GetExpertComputerResponse404
  | getV2GetExpertComputerResponse422
) & {
  headers: Headers;
};

export type getV2GetExpertComputerResponse =
  | getV2GetExpertComputerResponseSuccess
  | getV2GetExpertComputerResponseError;

export const getGetV2GetExpertComputerUrl = (expertId: string) => {
  return `/api/experts/${expertId}/computer`;
};

/**
 * The expert's own computer: its box as E2B lists it, and whether its
 * screen is on. E2B knows nothing about the screen; that flag is ours,
 * kept beside the box id, because asking the box would wake it.
 *
 * Listing never wakes a paused box, so the Computer tab can refresh freely.
 * @summary Get Expert Computer
 */
export const getV2GetExpertComputer = async (
  expertId: string,
  options?: RequestInit,
): Promise<getV2GetExpertComputerResponse> => {
  return customMutator<getV2GetExpertComputerResponse>(
    getGetV2GetExpertComputerUrl(expertId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetExpertComputerQueryKey = (expertId: string) => {
  return [`/api/experts/${expertId}/computer`] as const;
};

export const getGetV2GetExpertComputerQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetExpertComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertComputer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetExpertComputerQueryKey(expertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetExpertComputer>>
  > = ({ signal }) =>
    getV2GetExpertComputer(expertId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: expertId !== null && expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetExpertComputer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetExpertComputerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetExpertComputer>>
>;
export type GetV2GetExpertComputerQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useGetV2GetExpertComputer<
  TData = Awaited<ReturnType<typeof getV2GetExpertComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertComputer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExpertComputer>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExpertComputer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExpertComputer<
  TData = Awaited<ReturnType<typeof getV2GetExpertComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertComputer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExpertComputer>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExpertComputer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExpertComputer<
  TData = Awaited<ReturnType<typeof getV2GetExpertComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertComputer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Expert Computer
 */

export function useGetV2GetExpertComputer<
  TData = Awaited<ReturnType<typeof getV2GetExpertComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertComputer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetExpertComputerQueryOptions(expertId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Expert Computer
 */
export const prefetchGetV2GetExpertComputerQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetExpertComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertComputer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetExpertComputerQueryOptions(expertId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2StartExpertDesktopResponse200 = {
  data: DesktopStream;
  status: 200;
};

export type postV2StartExpertDesktopResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2StartExpertDesktopResponse404 = {
  data: void;
  status: 404;
};

export type postV2StartExpertDesktopResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2StartExpertDesktopResponse502 = {
  data: void;
  status: 502;
};

export type postV2StartExpertDesktopResponse503 = {
  data: void;
  status: 503;
};

export type postV2StartExpertDesktopResponseSuccess =
  postV2StartExpertDesktopResponse200 & {
    headers: Headers;
  };
export type postV2StartExpertDesktopResponseError = (
  | postV2StartExpertDesktopResponse401
  | postV2StartExpertDesktopResponse404
  | postV2StartExpertDesktopResponse422
  | postV2StartExpertDesktopResponse502
  | postV2StartExpertDesktopResponse503
) & {
  headers: Headers;
};

export type postV2StartExpertDesktopResponse =
  | postV2StartExpertDesktopResponseSuccess
  | postV2StartExpertDesktopResponseError;

export const getPostV2StartExpertDesktopUrl = (expertId: string) => {
  return `/api/experts/${expertId}/computer/desktop`;
};

/**
 * Start or resume the expert's desktop and return its live stream.
 *
 * This is the same box the expert's next ``start_desktop`` turn reconnects
 * to, so what the user does here is what the expert sees.
 * @summary Start Expert Desktop
 */
export const postV2StartExpertDesktop = async (
  expertId: string,
  options?: RequestInit,
): Promise<postV2StartExpertDesktopResponse> => {
  return customMutator<postV2StartExpertDesktopResponse>(
    getPostV2StartExpertDesktopUrl(expertId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2StartExpertDesktopMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2StartExpertDesktop>>,
    TError,
    { expertId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2StartExpertDesktop>>,
  TError,
  { expertId: string },
  TContext
> => {
  const mutationKey = ["postV2StartExpertDesktop"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2StartExpertDesktop>>,
    { expertId: string }
  > = (props) => {
    const { expertId } = props ?? {};

    return postV2StartExpertDesktop(expertId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2StartExpertDesktopMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2StartExpertDesktop>>
>;

export type PostV2StartExpertDesktopMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Start Expert Desktop
 */
export const usePostV2StartExpertDesktop = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2StartExpertDesktop>>,
      TError,
      { expertId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2StartExpertDesktop>>,
  TError,
  { expertId: string },
  TContext
> => {
  return useMutation(
    getPostV2StartExpertDesktopMutationOptions(options),
    queryClient,
  );
};
export type listExpertCredentialsResponse200 = {
  data: ExpertCredentialRef[];
  status: 200;
};

export type listExpertCredentialsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listExpertCredentialsResponse404 = {
  data: void;
  status: 404;
};

export type listExpertCredentialsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listExpertCredentialsResponseSuccess =
  listExpertCredentialsResponse200 & {
    headers: Headers;
  };
export type listExpertCredentialsResponseError = (
  | listExpertCredentialsResponse401
  | listExpertCredentialsResponse404
  | listExpertCredentialsResponse422
) & {
  headers: Headers;
};

export type listExpertCredentialsResponse =
  | listExpertCredentialsResponseSuccess
  | listExpertCredentialsResponseError;

export const getListExpertCredentialsUrl = (expertId: string) => {
  return `/api/experts/${expertId}/credentials`;
};

/**
 * The integrations this expert is allowed to use.
 * @summary List Expert Credentials
 */
export const listExpertCredentials = async (
  expertId: string,
  options?: RequestInit,
): Promise<listExpertCredentialsResponse> => {
  return customMutator<listExpertCredentialsResponse>(
    getListExpertCredentialsUrl(expertId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListExpertCredentialsQueryKey = (expertId: string) => {
  return [`/api/experts/${expertId}/credentials`] as const;
};

export const getListExpertCredentialsQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpertCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListExpertCredentialsQueryKey(expertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExpertCredentials>>
  > = ({ signal }) =>
    listExpertCredentials(expertId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: expertId !== null && expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpertCredentials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExpertCredentialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpertCredentials>>
>;
export type ListExpertCredentialsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useListExpertCredentials<
  TData = Awaited<ReturnType<typeof listExpertCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertCredentials>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertCredentials>>,
          TError,
          Awaited<ReturnType<typeof listExpertCredentials>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertCredentials<
  TData = Awaited<ReturnType<typeof listExpertCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertCredentials>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertCredentials>>,
          TError,
          Awaited<ReturnType<typeof listExpertCredentials>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertCredentials<
  TData = Awaited<ReturnType<typeof listExpertCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Credentials
 */

export function useListExpertCredentials<
  TData = Awaited<ReturnType<typeof listExpertCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExpertCredentialsQueryOptions(expertId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Credentials
 */
export const prefetchListExpertCredentialsQuery = async <
  TData = Awaited<ReturnType<typeof listExpertCredentials>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExpertCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListExpertCredentialsQueryOptions(expertId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type grantExpertCredentialsResponse200 = {
  data: ExpertCredentialRef[];
  status: 200;
};

export type grantExpertCredentialsResponse400 = {
  data: void;
  status: 400;
};

export type grantExpertCredentialsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type grantExpertCredentialsResponse404 = {
  data: void;
  status: 404;
};

export type grantExpertCredentialsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type grantExpertCredentialsResponseSuccess =
  grantExpertCredentialsResponse200 & {
    headers: Headers;
  };
export type grantExpertCredentialsResponseError = (
  | grantExpertCredentialsResponse400
  | grantExpertCredentialsResponse401
  | grantExpertCredentialsResponse404
  | grantExpertCredentialsResponse422
) & {
  headers: Headers;
};

export type grantExpertCredentialsResponse =
  | grantExpertCredentialsResponseSuccess
  | grantExpertCredentialsResponseError;

export const getGrantExpertCredentialsUrl = (expertId: string) => {
  return `/api/experts/${expertId}/credentials`;
};

/**
 * @summary Grant Expert Credentials
 */
export const grantExpertCredentials = async (
  expertId: string,
  grantCredentialsRequest: GrantCredentialsRequest,
  options?: RequestInit,
): Promise<grantExpertCredentialsResponse> => {
  return customMutator<grantExpertCredentialsResponse>(
    getGrantExpertCredentialsUrl(expertId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(grantCredentialsRequest),
    },
  );
};

export const getGrantExpertCredentialsMutationOptions = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantExpertCredentials>>,
    TError,
    { expertId: string; data: GrantCredentialsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantExpertCredentials>>,
  TError,
  { expertId: string; data: GrantCredentialsRequest },
  TContext
> => {
  const mutationKey = ["grantExpertCredentials"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantExpertCredentials>>,
    { expertId: string; data: GrantCredentialsRequest }
  > = (props) => {
    const { expertId, data } = props ?? {};

    return grantExpertCredentials(expertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantExpertCredentialsMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantExpertCredentials>>
>;
export type GrantExpertCredentialsMutationBody = GrantCredentialsRequest;
export type GrantExpertCredentialsMutationError =
  | void
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Grant Expert Credentials
 */
export const useGrantExpertCredentials = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantExpertCredentials>>,
      TError,
      { expertId: string; data: GrantCredentialsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof grantExpertCredentials>>,
  TError,
  { expertId: string; data: GrantCredentialsRequest },
  TContext
> => {
  return useMutation(
    getGrantExpertCredentialsMutationOptions(options),
    queryClient,
  );
};
export type revokeExpertCredentialResponse200 = {
  data: ExpertCredentialRef[];
  status: 200;
};

export type revokeExpertCredentialResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type revokeExpertCredentialResponse404 = {
  data: void;
  status: 404;
};

export type revokeExpertCredentialResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type revokeExpertCredentialResponseSuccess =
  revokeExpertCredentialResponse200 & {
    headers: Headers;
  };
export type revokeExpertCredentialResponseError = (
  | revokeExpertCredentialResponse401
  | revokeExpertCredentialResponse404
  | revokeExpertCredentialResponse422
) & {
  headers: Headers;
};

export type revokeExpertCredentialResponse =
  | revokeExpertCredentialResponseSuccess
  | revokeExpertCredentialResponseError;

export const getRevokeExpertCredentialUrl = (
  expertId: string,
  credentialId: string,
) => {
  return `/api/experts/${expertId}/credentials/${credentialId}`;
};

/**
 * @summary Revoke Expert Credential
 */
export const revokeExpertCredential = async (
  expertId: string,
  credentialId: string,
  options?: RequestInit,
): Promise<revokeExpertCredentialResponse> => {
  return customMutator<revokeExpertCredentialResponse>(
    getRevokeExpertCredentialUrl(expertId, credentialId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRevokeExpertCredentialMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeExpertCredential>>,
    TError,
    { expertId: string; credentialId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeExpertCredential>>,
  TError,
  { expertId: string; credentialId: string },
  TContext
> => {
  const mutationKey = ["revokeExpertCredential"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeExpertCredential>>,
    { expertId: string; credentialId: string }
  > = (props) => {
    const { expertId, credentialId } = props ?? {};

    return revokeExpertCredential(expertId, credentialId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeExpertCredentialMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeExpertCredential>>
>;

export type RevokeExpertCredentialMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Revoke Expert Credential
 */
export const useRevokeExpertCredential = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeExpertCredential>>,
      TError,
      { expertId: string; credentialId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof revokeExpertCredential>>,
  TError,
  { expertId: string; credentialId: string },
  TContext
> => {
  return useMutation(
    getRevokeExpertCredentialMutationOptions(options),
    queryClient,
  );
};
export type getExpertDetachPreviewResponse200 = {
  data: ExpertDetachPreview;
  status: 200;
};

export type getExpertDetachPreviewResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getExpertDetachPreviewResponse404 = {
  data: void;
  status: 404;
};

export type getExpertDetachPreviewResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getExpertDetachPreviewResponseSuccess =
  getExpertDetachPreviewResponse200 & {
    headers: Headers;
  };
export type getExpertDetachPreviewResponseError = (
  | getExpertDetachPreviewResponse401
  | getExpertDetachPreviewResponse404
  | getExpertDetachPreviewResponse422
) & {
  headers: Headers;
};

export type getExpertDetachPreviewResponse =
  | getExpertDetachPreviewResponseSuccess
  | getExpertDetachPreviewResponseError;

export const getGetExpertDetachPreviewUrl = (expertId: string) => {
  return `/api/experts/${expertId}/detach-preview`;
};

/**
 * What archiving this expert would pause — schedules and triggers —
 * so the client can show a clear confirmation prompt.
 * @summary Get Expert Detach Preview
 */
export const getExpertDetachPreview = async (
  expertId: string,
  options?: RequestInit,
): Promise<getExpertDetachPreviewResponse> => {
  return customMutator<getExpertDetachPreviewResponse>(
    getGetExpertDetachPreviewUrl(expertId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetExpertDetachPreviewQueryKey = (expertId: string) => {
  return [`/api/experts/${expertId}/detach-preview`] as const;
};

export const getGetExpertDetachPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpertDetachPreview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertDetachPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExpertDetachPreviewQueryKey(expertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExpertDetachPreview>>
  > = ({ signal }) =>
    getExpertDetachPreview(expertId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: expertId !== null && expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExpertDetachPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExpertDetachPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExpertDetachPreview>>
>;
export type GetExpertDetachPreviewQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useGetExpertDetachPreview<
  TData = Awaited<ReturnType<typeof getExpertDetachPreview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertDetachPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertDetachPreview>>,
          TError,
          Awaited<ReturnType<typeof getExpertDetachPreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpertDetachPreview<
  TData = Awaited<ReturnType<typeof getExpertDetachPreview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertDetachPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertDetachPreview>>,
          TError,
          Awaited<ReturnType<typeof getExpertDetachPreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpertDetachPreview<
  TData = Awaited<ReturnType<typeof getExpertDetachPreview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertDetachPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Expert Detach Preview
 */

export function useGetExpertDetachPreview<
  TData = Awaited<ReturnType<typeof getExpertDetachPreview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertDetachPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExpertDetachPreviewQueryOptions(expertId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Expert Detach Preview
 */
export const prefetchGetExpertDetachPreviewQuery = async <
  TData = Awaited<ReturnType<typeof getExpertDetachPreview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertDetachPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetExpertDetachPreviewQueryOptions(expertId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type updateExpertModeResponse200 = {
  data: Expert;
  status: 200;
};

export type updateExpertModeResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type updateExpertModeResponse403 = {
  data: void;
  status: 403;
};

export type updateExpertModeResponse404 = {
  data: void;
  status: 404;
};

export type updateExpertModeResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateExpertModeResponseSuccess = updateExpertModeResponse200 & {
  headers: Headers;
};
export type updateExpertModeResponseError = (
  | updateExpertModeResponse401
  | updateExpertModeResponse403
  | updateExpertModeResponse404
  | updateExpertModeResponse422
) & {
  headers: Headers;
};

export type updateExpertModeResponse =
  | updateExpertModeResponseSuccess
  | updateExpertModeResponseError;

export const getUpdateExpertModeUrl = (expertId: string) => {
  return `/api/experts/${expertId}/mode`;
};

/**
 * Set the approval mode new web chats with this expert start on.
 *
 * Threads already open keep the mode stored on them, and the composer's
 * selector still overrides it per thread. Routines, scheduled follow-ups
 * and chats driven from a linked chat platform are not gated by it.
 * @summary Update Expert Mode
 */
export const updateExpertMode = async (
  expertId: string,
  expertModeUpdate: ExpertModeUpdate,
  options?: RequestInit,
): Promise<updateExpertModeResponse> => {
  return customMutator<updateExpertModeResponse>(
    getUpdateExpertModeUrl(expertId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(expertModeUpdate),
    },
  );
};

export const getUpdateExpertModeMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpertMode>>,
    TError,
    { expertId: string; data: ExpertModeUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExpertMode>>,
  TError,
  { expertId: string; data: ExpertModeUpdate },
  TContext
> => {
  const mutationKey = ["updateExpertMode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExpertMode>>,
    { expertId: string; data: ExpertModeUpdate }
  > = (props) => {
    const { expertId, data } = props ?? {};

    return updateExpertMode(expertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExpertModeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExpertMode>>
>;
export type UpdateExpertModeMutationBody = ExpertModeUpdate;
export type UpdateExpertModeMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Update Expert Mode
 */
export const useUpdateExpertMode = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateExpertMode>>,
      TError,
      { expertId: string; data: ExpertModeUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateExpertMode>>,
  TError,
  { expertId: string; data: ExpertModeUpdate },
  TContext
> => {
  return useMutation(getUpdateExpertModeMutationOptions(options), queryClient);
};
export type getExpertOnboardingResponse200 = {
  data: PendingExpertOnboarding | null;
  status: 200;
};

export type getExpertOnboardingResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getExpertOnboardingResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getExpertOnboardingResponseSuccess =
  getExpertOnboardingResponse200 & {
    headers: Headers;
  };
export type getExpertOnboardingResponseError = (
  | getExpertOnboardingResponse401
  | getExpertOnboardingResponse422
) & {
  headers: Headers;
};

export type getExpertOnboardingResponse =
  | getExpertOnboardingResponseSuccess
  | getExpertOnboardingResponseError;

export const getGetExpertOnboardingUrl = (expertId: string) => {
  return `/api/experts/${expertId}/onboarding`;
};

/**
 * @summary Get Expert Onboarding
 */
export const getExpertOnboarding = async (
  expertId: string,
  options?: RequestInit,
): Promise<getExpertOnboardingResponse> => {
  return customMutator<getExpertOnboardingResponse>(
    getGetExpertOnboardingUrl(expertId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetExpertOnboardingQueryKey = (expertId: string) => {
  return [`/api/experts/${expertId}/onboarding`] as const;
};

export const getGetExpertOnboardingQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpertOnboarding>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOnboarding>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExpertOnboardingQueryKey(expertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExpertOnboarding>>
  > = ({ signal }) =>
    getExpertOnboarding(expertId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: expertId !== null && expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExpertOnboarding>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExpertOnboardingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExpertOnboarding>>
>;
export type GetExpertOnboardingQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetExpertOnboarding<
  TData = Awaited<ReturnType<typeof getExpertOnboarding>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  expertId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOnboarding>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertOnboarding>>,
          TError,
          Awaited<ReturnType<typeof getExpertOnboarding>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpertOnboarding<
  TData = Awaited<ReturnType<typeof getExpertOnboarding>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOnboarding>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertOnboarding>>,
          TError,
          Awaited<ReturnType<typeof getExpertOnboarding>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExpertOnboarding<
  TData = Awaited<ReturnType<typeof getExpertOnboarding>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOnboarding>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Expert Onboarding
 */

export function useGetExpertOnboarding<
  TData = Awaited<ReturnType<typeof getExpertOnboarding>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOnboarding>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExpertOnboardingQueryOptions(expertId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Expert Onboarding
 */
export const prefetchGetExpertOnboardingQuery = async <
  TData = Awaited<ReturnType<typeof getExpertOnboarding>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOnboarding>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetExpertOnboardingQueryOptions(expertId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type assignExpertPodResponse200 = {
  data: Expert;
  status: 200;
};

export type assignExpertPodResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type assignExpertPodResponse404 = {
  data: void;
  status: 404;
};

export type assignExpertPodResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type assignExpertPodResponseSuccess = assignExpertPodResponse200 & {
  headers: Headers;
};
export type assignExpertPodResponseError = (
  | assignExpertPodResponse401
  | assignExpertPodResponse404
  | assignExpertPodResponse422
) & {
  headers: Headers;
};

export type assignExpertPodResponse =
  | assignExpertPodResponseSuccess
  | assignExpertPodResponseError;

export const getAssignExpertPodUrl = (expertId: string) => {
  return `/api/experts/${expertId}/pod`;
};

/**
 * @summary Assign Expert Pod
 */
export const assignExpertPod = async (
  expertId: string,
  assignPodRequest: AssignPodRequest,
  options?: RequestInit,
): Promise<assignExpertPodResponse> => {
  return customMutator<assignExpertPodResponse>(
    getAssignExpertPodUrl(expertId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(assignPodRequest),
    },
  );
};

export const getAssignExpertPodMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignExpertPod>>,
    TError,
    { expertId: string; data: AssignPodRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignExpertPod>>,
  TError,
  { expertId: string; data: AssignPodRequest },
  TContext
> => {
  const mutationKey = ["assignExpertPod"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignExpertPod>>,
    { expertId: string; data: AssignPodRequest }
  > = (props) => {
    const { expertId, data } = props ?? {};

    return assignExpertPod(expertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignExpertPodMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignExpertPod>>
>;
export type AssignExpertPodMutationBody = AssignPodRequest;
export type AssignExpertPodMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Assign Expert Pod
 */
export const useAssignExpertPod = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignExpertPod>>,
      TError,
      { expertId: string; data: AssignPodRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof assignExpertPod>>,
  TError,
  { expertId: string; data: AssignPodRequest },
  TContext
> => {
  return useMutation(getAssignExpertPodMutationOptions(options), queryClient);
};
export type listExpertRunsResponse200 = {
  data: ExpertRun[];
  status: 200;
};

export type listExpertRunsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listExpertRunsResponse404 = {
  data: void;
  status: 404;
};

export type listExpertRunsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listExpertRunsResponseSuccess = listExpertRunsResponse200 & {
  headers: Headers;
};
export type listExpertRunsResponseError = (
  | listExpertRunsResponse401
  | listExpertRunsResponse404
  | listExpertRunsResponse422
) & {
  headers: Headers;
};

export type listExpertRunsResponse =
  | listExpertRunsResponseSuccess
  | listExpertRunsResponseError;

export const getListExpertRunsUrl = (expertId: string) => {
  return `/api/experts/${expertId}/runs`;
};

/**
 * Recent executions attributed to this expert, with a classified output
 * type for the Work surface's typed viewer.
 * @summary List Expert Runs
 */
export const listExpertRuns = async (
  expertId: string,
  options?: RequestInit,
): Promise<listExpertRunsResponse> => {
  return customMutator<listExpertRunsResponse>(getListExpertRunsUrl(expertId), {
    ...options,
    method: "GET",
  });
};

export const getListExpertRunsQueryKey = (expertId: string) => {
  return [`/api/experts/${expertId}/runs`] as const;
};

export const getListExpertRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpertRuns>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListExpertRunsQueryKey(expertId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpertRuns>>> = ({
    signal,
  }) => listExpertRuns(expertId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: expertId !== null && expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpertRuns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExpertRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpertRuns>>
>;
export type ListExpertRunsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useListExpertRuns<
  TData = Awaited<ReturnType<typeof listExpertRuns>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertRuns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertRuns>>,
          TError,
          Awaited<ReturnType<typeof listExpertRuns>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertRuns<
  TData = Awaited<ReturnType<typeof listExpertRuns>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertRuns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertRuns>>,
          TError,
          Awaited<ReturnType<typeof listExpertRuns>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExpertRuns<
  TData = Awaited<ReturnType<typeof listExpertRuns>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Runs
 */

export function useListExpertRuns<
  TData = Awaited<ReturnType<typeof listExpertRuns>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExpertRunsQueryOptions(expertId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Runs
 */
export const prefetchListExpertRunsQuery = async <
  TData = Awaited<ReturnType<typeof listExpertRuns>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExpertRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListExpertRunsQueryOptions(expertId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type resumeExpertSchedulesResponse200 = {
  data: Expert;
  status: 200;
};

export type resumeExpertSchedulesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type resumeExpertSchedulesResponse404 = {
  data: void;
  status: 404;
};

export type resumeExpertSchedulesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type resumeExpertSchedulesResponseSuccess =
  resumeExpertSchedulesResponse200 & {
    headers: Headers;
  };
export type resumeExpertSchedulesResponseError = (
  | resumeExpertSchedulesResponse401
  | resumeExpertSchedulesResponse404
  | resumeExpertSchedulesResponse422
) & {
  headers: Headers;
};

export type resumeExpertSchedulesResponse =
  | resumeExpertSchedulesResponseSuccess
  | resumeExpertSchedulesResponseError;

export const getResumeExpertSchedulesUrl = (expertId: string) => {
  return `/api/experts/${expertId}/schedules/resume`;
};

/**
 * One-click reversal of a budget/archive pause.
 * @summary Resume Expert Schedules
 */
export const resumeExpertSchedules = async (
  expertId: string,
  options?: RequestInit,
): Promise<resumeExpertSchedulesResponse> => {
  return customMutator<resumeExpertSchedulesResponse>(
    getResumeExpertSchedulesUrl(expertId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getResumeExpertSchedulesMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeExpertSchedules>>,
    TError,
    { expertId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeExpertSchedules>>,
  TError,
  { expertId: string },
  TContext
> => {
  const mutationKey = ["resumeExpertSchedules"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeExpertSchedules>>,
    { expertId: string }
  > = (props) => {
    const { expertId } = props ?? {};

    return resumeExpertSchedules(expertId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeExpertSchedulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeExpertSchedules>>
>;

export type ResumeExpertSchedulesMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Resume Expert Schedules
 */
export const useResumeExpertSchedules = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resumeExpertSchedules>>,
      TError,
      { expertId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resumeExpertSchedules>>,
  TError,
  { expertId: string },
  TContext
> => {
  return useMutation(
    getResumeExpertSchedulesMutationOptions(options),
    queryClient,
  );
};
export type updateExpertSkillsResponse200 = {
  data: Expert;
  status: 200;
};

export type updateExpertSkillsResponse400 = {
  data: void;
  status: 400;
};

export type updateExpertSkillsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type updateExpertSkillsResponse404 = {
  data: void;
  status: 404;
};

export type updateExpertSkillsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateExpertSkillsResponseSuccess =
  updateExpertSkillsResponse200 & {
    headers: Headers;
  };
export type updateExpertSkillsResponseError = (
  | updateExpertSkillsResponse400
  | updateExpertSkillsResponse401
  | updateExpertSkillsResponse404
  | updateExpertSkillsResponse422
) & {
  headers: Headers;
};

export type updateExpertSkillsResponse =
  | updateExpertSkillsResponseSuccess
  | updateExpertSkillsResponseError;

export const getUpdateExpertSkillsUrl = (expertId: string) => {
  return `/api/experts/${expertId}/skills`;
};

/**
 * @summary Update Expert Skills
 */
export const updateExpertSkills = async (
  expertId: string,
  expertSkillsUpdate: ExpertSkillsUpdate,
  options?: RequestInit,
): Promise<updateExpertSkillsResponse> => {
  return customMutator<updateExpertSkillsResponse>(
    getUpdateExpertSkillsUrl(expertId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(expertSkillsUpdate),
    },
  );
};

export const getUpdateExpertSkillsMutationOptions = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpertSkills>>,
    TError,
    { expertId: string; data: ExpertSkillsUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExpertSkills>>,
  TError,
  { expertId: string; data: ExpertSkillsUpdate },
  TContext
> => {
  const mutationKey = ["updateExpertSkills"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExpertSkills>>,
    { expertId: string; data: ExpertSkillsUpdate }
  > = (props) => {
    const { expertId, data } = props ?? {};

    return updateExpertSkills(expertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExpertSkillsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExpertSkills>>
>;
export type UpdateExpertSkillsMutationBody = ExpertSkillsUpdate;
export type UpdateExpertSkillsMutationError =
  | void
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update Expert Skills
 */
export const useUpdateExpertSkills = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateExpertSkills>>,
      TError,
      { expertId: string; data: ExpertSkillsUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateExpertSkills>>,
  TError,
  { expertId: string; data: ExpertSkillsUpdate },
  TContext
> => {
  return useMutation(
    getUpdateExpertSkillsMutationOptions(options),
    queryClient,
  );
};
export type updateExpertSoulResponse200 = {
  data: Expert;
  status: 200;
};

export type updateExpertSoulResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type updateExpertSoulResponse404 = {
  data: void;
  status: 404;
};

export type updateExpertSoulResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateExpertSoulResponseSuccess = updateExpertSoulResponse200 & {
  headers: Headers;
};
export type updateExpertSoulResponseError = (
  | updateExpertSoulResponse401
  | updateExpertSoulResponse404
  | updateExpertSoulResponse422
) & {
  headers: Headers;
};

export type updateExpertSoulResponse =
  | updateExpertSoulResponseSuccess
  | updateExpertSoulResponseError;

export const getUpdateExpertSoulUrl = (expertId: string) => {
  return `/api/experts/${expertId}/soul`;
};

/**
 * @summary Update Expert Soul
 */
export const updateExpertSoul = async (
  expertId: string,
  expertSoulUpdate: ExpertSoulUpdate,
  options?: RequestInit,
): Promise<updateExpertSoulResponse> => {
  return customMutator<updateExpertSoulResponse>(
    getUpdateExpertSoulUrl(expertId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(expertSoulUpdate),
    },
  );
};

export const getUpdateExpertSoulMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpertSoul>>,
    TError,
    { expertId: string; data: ExpertSoulUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExpertSoul>>,
  TError,
  { expertId: string; data: ExpertSoulUpdate },
  TContext
> => {
  const mutationKey = ["updateExpertSoul"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExpertSoul>>,
    { expertId: string; data: ExpertSoulUpdate }
  > = (props) => {
    const { expertId, data } = props ?? {};

    return updateExpertSoul(expertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExpertSoulMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExpertSoul>>
>;
export type UpdateExpertSoulMutationBody = ExpertSoulUpdate;
export type UpdateExpertSoulMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Update Expert Soul
 */
export const useUpdateExpertSoul = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateExpertSoul>>,
      TError,
      { expertId: string; data: ExpertSoulUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateExpertSoul>>,
  TError,
  { expertId: string; data: ExpertSoulUpdate },
  TContext
> => {
  return useMutation(getUpdateExpertSoulMutationOptions(options), queryClient);
};
export type installExpertWorkflowResponse200 = {
  data: ExpertWorkflowRef;
  status: 200;
};

export type installExpertWorkflowResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type installExpertWorkflowResponse404 = {
  data: void;
  status: 404;
};

export type installExpertWorkflowResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type installExpertWorkflowResponseSuccess =
  installExpertWorkflowResponse200 & {
    headers: Headers;
  };
export type installExpertWorkflowResponseError = (
  | installExpertWorkflowResponse401
  | installExpertWorkflowResponse404
  | installExpertWorkflowResponse422
) & {
  headers: Headers;
};

export type installExpertWorkflowResponse =
  | installExpertWorkflowResponseSuccess
  | installExpertWorkflowResponseError;

export const getInstallExpertWorkflowUrl = (expertId: string) => {
  return `/api/experts/${expertId}/workflows`;
};

/**
 * @summary Install Expert Workflow
 */
export const installExpertWorkflow = async (
  expertId: string,
  installWorkflowRequest: InstallWorkflowRequest,
  options?: RequestInit,
): Promise<installExpertWorkflowResponse> => {
  return customMutator<installExpertWorkflowResponse>(
    getInstallExpertWorkflowUrl(expertId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(installWorkflowRequest),
    },
  );
};

export const getInstallExpertWorkflowMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof installExpertWorkflow>>,
    TError,
    { expertId: string; data: InstallWorkflowRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof installExpertWorkflow>>,
  TError,
  { expertId: string; data: InstallWorkflowRequest },
  TContext
> => {
  const mutationKey = ["installExpertWorkflow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof installExpertWorkflow>>,
    { expertId: string; data: InstallWorkflowRequest }
  > = (props) => {
    const { expertId, data } = props ?? {};

    return installExpertWorkflow(expertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InstallExpertWorkflowMutationResult = NonNullable<
  Awaited<ReturnType<typeof installExpertWorkflow>>
>;
export type InstallExpertWorkflowMutationBody = InstallWorkflowRequest;
export type InstallExpertWorkflowMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Install Expert Workflow
 */
export const useInstallExpertWorkflow = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof installExpertWorkflow>>,
      TError,
      { expertId: string; data: InstallWorkflowRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof installExpertWorkflow>>,
  TError,
  { expertId: string; data: InstallWorkflowRequest },
  TContext
> => {
  return useMutation(
    getInstallExpertWorkflowMutationOptions(options),
    queryClient,
  );
};
export type removeExpertWorkflowResponse204 = {
  data: void;
  status: 204;
};

export type removeExpertWorkflowResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type removeExpertWorkflowResponse404 = {
  data: void;
  status: 404;
};

export type removeExpertWorkflowResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type removeExpertWorkflowResponse503 = {
  data: void;
  status: 503;
};

export type removeExpertWorkflowResponseSuccess =
  removeExpertWorkflowResponse204 & {
    headers: Headers;
  };
export type removeExpertWorkflowResponseError = (
  | removeExpertWorkflowResponse401
  | removeExpertWorkflowResponse404
  | removeExpertWorkflowResponse422
  | removeExpertWorkflowResponse503
) & {
  headers: Headers;
};

export type removeExpertWorkflowResponse =
  | removeExpertWorkflowResponseSuccess
  | removeExpertWorkflowResponseError;

export const getRemoveExpertWorkflowUrl = (
  expertId: string,
  workflowId: string,
) => {
  return `/api/experts/${expertId}/workflows/${workflowId}`;
};

/**
 * @summary Remove Expert Workflow
 */
export const removeExpertWorkflow = async (
  expertId: string,
  workflowId: string,
  options?: RequestInit,
): Promise<removeExpertWorkflowResponse> => {
  return customMutator<removeExpertWorkflowResponse>(
    getRemoveExpertWorkflowUrl(expertId, workflowId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveExpertWorkflowMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeExpertWorkflow>>,
    TError,
    { expertId: string; workflowId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeExpertWorkflow>>,
  TError,
  { expertId: string; workflowId: string },
  TContext
> => {
  const mutationKey = ["removeExpertWorkflow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeExpertWorkflow>>,
    { expertId: string; workflowId: string }
  > = (props) => {
    const { expertId, workflowId } = props ?? {};

    return removeExpertWorkflow(expertId, workflowId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveExpertWorkflowMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeExpertWorkflow>>
>;

export type RemoveExpertWorkflowMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Remove Expert Workflow
 */
export const useRemoveExpertWorkflow = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeExpertWorkflow>>,
      TError,
      { expertId: string; workflowId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeExpertWorkflow>>,
  TError,
  { expertId: string; workflowId: string },
  TContext
> => {
  return useMutation(
    getRemoveExpertWorkflowMutationOptions(options),
    queryClient,
  );
};
